// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeBlock_container__2UTpv","fullWidth":"HomeBlock_fullWidth__1wvGl","noPadding":"HomeBlock_noPadding__3KW62"};